var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedbackfaces"},_vm._l((5),function(index){return _c('img',{key:index,attrs:{"src":_vm.getSRC(index),"id":index,"data-id":index},on:{"click":function($event){_vm.$emit('clicked-face', index);
      _vm.setActive($event);}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }